import { AutoDeliveryConfigData } from './types'

const MockAutoDeliveryConfig: AutoDeliveryConfigData = {
  canCreateAD: true,
  marketId: 'CZ',
  periodicities: [
    {
      periodicity: 'MONTHLY',
      maxCart: 4,
      categories: [{ categoryId: 'TOBACCO_STICKS' }],
      products: ['G0000699', 'G0000799']
    },
    {
      periodicity: 'WEEKLY',
      maxCart: 2,
      categories: [{ categoryId: 'TOBACCO_STICKS' }],
      products: ['G0000601', 'G0000602']
    }
  ],
  defaultPeriodicity: 'MONTHLY',
  platformsLimits: ['WEB', 'MOBILE'],
  segments: ['PREMIUM', 'STANDARD'],
  resetSkipCountOnOrderCreation: false,
  minStartDate: '2026-01-01T12:34:56.123456789Z',
  maxStartDate: '2026-02-01T12:34:56.123456789Z',
  status: 200
}

export default MockAutoDeliveryConfig
